import { render } from "./InspectorTableDisplayDialog.vue?vue&type=template&id=dd9a874e"
import script from "./InspectorTableDisplayDialog.vue?vue&type=script&lang=js"
export * from "./InspectorTableDisplayDialog.vue?vue&type=script&lang=js"

import "./InspectorTableDisplayDialog.vue?vue&type=style&index=0&id=dd9a874e&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCard from 'quasar/src/components/card/QCard.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn,QCard});qInstall(script, 'directives', {ClosePopup});
